import { MAX_VINTRO_TIME, MAX_VNOTE_TIME } from "../constants";

export enum RecorderType{
    VNOTE = MAX_VNOTE_TIME,
    INTRO = MAX_VINTRO_TIME
}